
document.addEventListener("DOMContentLoaded", function () {
  
  const currentPath = window.location.pathname;
document.querySelectorAll('.header__primary-nav-item summary').forEach(link => {
  if (link.getAttribute('data-follow-link') === currentPath) {
    link.classList.add('active-link');
  }
});
document.querySelectorAll('.header__primary-nav-item a').forEach(link => {
  if (link.getAttribute('href') === currentPath) {
    link.classList.add('active-link');
  }
});
  
});

 const button_newsletter = document.getElementById('Subscribe');

    // Add a click event listener
    button_newsletter.addEventListener('click', function() {
      // Change the content of the paragraph
     button_newsletter.style = "background: #f77552; color: white;"
    });